import { render, staticRenderFns } from "./RightAttributePanel.vue?vue&type=template&id=13904e90&scoped=true&"
import script from "./RightAttributePanel.vue?vue&type=script&lang=js&"
export * from "./RightAttributePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13904e90",
  null
  
)

export default component.exports